import initializeElement from "src/decidim/accountability/admin/imports";
window.addEventListener("DOMContentLoaded", initializeElement);
